import { render, staticRenderFns } from "./SectionTestimonials.vue?vue&type=template&id=a3a0ea72&scoped=true&"
import script from "./SectionTestimonials.vue?vue&type=script&lang=js&"
export * from "./SectionTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./SectionTestimonials.vue?vue&type=style&index=0&id=a3a0ea72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a0ea72",
  null
  
)

export default component.exports